/* eslint-disable */
import { FuseNavigationItem } from "@fuse/components/navigation";

import { environment } from "environments/environment.prod";

const showV2 = environment.projectName === "CORTIJO";

export const defaultNavigation: FuseNavigationItem[] = [
  //#region DASHBOARDS
  {
    id: "ave",
    title: "DASHBOARD",
    subtitle: "Gráficos Embebidos",
    type: "group",
    children: [
      {
        id: "ave.dashboard",
        title: "Cloud Sales Mobile",
        type: "basic",
        icon: "heroicons_outline:device-phone-mobile",
        link: "/dashboard/mobile",
      },
    ],
  },
  //#endregion

  //#region APLICACIONES
  {
    id: "applications",
    title: "APLICACIONES",
    subtitle: "Control y Operatividad",
    type: "group",
    children: [
      {
        id: "ave.assistant",
        title: "Asistente",
        type: "collapsable",
        icon: "heroicons_outline:sparkles",
        children: [
          {
            id: "ave.assistant.sales.distribution",
            title: "Distribución de Inventario",
            type: "basic",
            link: "/assistant/sales/distribution",
            badge: {
              title: "+IA",
              classes: "px-2 bg-purple-300 text-black rounded-full",
            },
          },
          {
            id: "ave.assistant.delivery.loads",
            title: "Asignación de Carga",
            type: "basic",
            link: "/assistant/delivery/loads",
            badge: {
              title: "+IA",
              classes: "px-2 bg-purple-300 text-black rounded-full",
            },
          },
        ],
      },
      {
        id: "ave.assistant.sales",
        title: "Samantha",
        type: "collapsable",
        icon: "heroicons_outline:cpu-chip",
        children: [
          {
            id: "ave.assistant.sales.suggerted-sales",
            title: "Predicción de Ventas",
            type: "basic",
            link: "/assistant/sales/suggested-sales",
            badge: {
              title: "+IA",
              classes: "px-2 bg-purple-300 text-black rounded-full",
            },
          },
          {
            id: "ave.assistant.sales.routes.optimization",
            title: "Optimización de Rutas",
            type: "basic",
            link: "/assistant/sales/optimization-routes",
            badge: {
              title: "+IA",
              classes: "px-2 bg-purple-300 text-black rounded-full",
            },
          },
        ],
      },
      {
        id: "ave.process.sales",
        title: "Ventas",
        type: "collapsable",
        icon: "heroicons_outline:arrow-trending-up",
        children: [
          {
            id: "ave.process.sales.monitor",
            title: "Monitor",
            type: "collapsable",
            children: [
              {
                id: "ave.monitor",
                title: "De Rutas",
                type: "basic",
                link: "/monitor/principal-screen",
              },
              {
                id: "ave.process.sales.trip",
                title: "De Estados de Viaje",
                type: "basic",
                link: "/master/sales/trip",
              },
              {
                id: "ave.reports.historic.attention-stock",
                title: "De Stock",
                type: "basic",
                link: "/reports/historic/attention-stock",
              },
            ],
          },
          {
            id: "ave.process.sales.generation",
            title: "Generación",
            type: "collapsable",
            children: [
              {
                id: "ave.process.sales.quotation-generate",
                title: "De Cotizaciones",
                type: "basic",
                link: "/master/sales/quotation-generate",
              },
              {
                id: "ave.process.sales.order-generate",
                title: "De Pedidos",
                type: "basic",
                link: "/master/sales/order-generate",
              },
            ],
          },
          {
            id: "ave.process.sales.request",
            title: "Solicitudes",
            type: "collapsable",
            children: [
              {
                id: "ave.process.sales.request-change-item-list",
                title: "De Cambios",
                type: "basic",
                link: "/master/sales/request-change-item-list",
              },
              {
                id: "ave.process.sales.request-return-list",
                title: "De Devoluciones",
                type: "basic",
                link: "/master/sales/request-return-list",
              },
              {
                id: "ave.process.request.seller-order",
                title: "De Vendedores",
                type: "basic",
                link: "/master/request/seller-order",
              },
              {
                id: "ave.process.sales.geolocation",
                title: "De Actualizar GPS",
                type: "basic",
                link: "/master/sales/geolocation-pending",
              },
            ],
          },
          {
            id: "ave.process.sales.listings",
            title: "Listados",
            type: "collapsable",
            children: [
              {
                id: "ave.process.sales.quotation-list",
                title: "De Cotizaciones",
                type: "basic",
                link: "/master/sales/quotation-list",
              },
              {
                id: "ave.process.sales.orders-list",
                title: "De Pedidos",
                type: "basic",
                link: "/master/sales/orders-list",
              },
              {
                id: "ave.process.sales.load-documents-list",
                title: "De Cargas In/Out",
                type: "basic",
                link: "/master/sales/load-documents-list",
              },
              {
                id: "ave.process.sales.delivery-list",
                title: "De Entregas",
                type: "basic",
                link: "/master/sales/delivery-list",
              },
              {
                id: "ave.process.sales.invoice-list",
                title: "De Facturas",
                type: "basic",
                link: "/master/sales/invoice-list",
              },
              {
                id: "ave.process.sales.change-item-list",
                title: "De Cambios",
                type: "basic",
                link: "/master/sales/change-item-list",
              },
              {
                id: "ave.process.sales.return-list",
                title: "De Devoluciones",
                type: "basic",
                link: "/master/sales/return-list",
              },
              {
                id: "ave.process.sales.loss-list",
                title: "De Mermas",
                type: "basic",
                link: "/master/sales/loss-list",
              },
            ],
          },
        ],
      },
      {
        id: "ave.process.collections",
        title: "Finanzas",
        type: "collapsable",
        icon: "heroicons_outline:banknotes",
        permission: ["ALL", "FICO"],
        children: [
          {
            id: "ave.process.collections.payment-management",
            title: "Cobranzas",
            type: "basic",
            permission: ["ALL", "FICO"],
            link: "/master/collections/payment-management",
          },
          {
            id: "ave.process.collections.open-items",
            title: "Partidas Abiertas",
            type: "basic",
            permission: ["ALL", "FICO"],
            link: "/master/collections/open-items",
          },                   
          {
            id: "ave.process.collections.expense-list",
            title: "Gastos",
            type: "basic",
            link: "/master/collections/expense-list",
          },
        ],
      },
      {
        id: "ave.reports",
        title: "Reportes",
        type: "collapsable",
        icon: "heroicons_outline:document-text",
        children: [
          {
            id: "ave.reports.sales",
            title: "Ventas",
            type: "collapsable",
            children: [
              {
                id: "ave.reports.sales.requests",
                title: "Solicitudes",
                type: "collapsable",
                children: [
                  {
                    id: "ave.reports.historic.request-change",
                    title: "De Cambios",
                    type: "basic",
                    link: "/reports/historic/request-change",
                  },
                  {
                    id: "ave.reports.historic.return-product-request",
                    title: "De Devoluciones",
                    type: "basic",
                    link: "/reports/historic/return-product-request",
                  },
                  {
                    id: "ave.reports.historic.order-seller",
                    title: "De Vendedores",
                    type: "basic",
                    link: "/reports/historic/order-seller",
                  },
                ],
              },
              {
                id: "ave.reports.sales.listings",
                title: "Listados",
                type: "collapsable",
                children: [
                  {
                    id: "ave.reports.historic.quotation-list",
                    title: "Cotizaciones",
                    type: "basic",
                    link: "",
                  },
                  {
                    id: "ave.reports.historic.order-customer",
                    title: "Pedidos",
                    type: "basic",
                    link: "/reports/historic/order-customer",
                  },
                  {
                    id: "ave.reports.historic.charge-int-out",
                    title: "Carga In/Out",
                    type: "basic",
                    link: "/reports/historic/charge-in-out",
                  },
                  {
                    id: "ave.reports.historic.delivery",
                    title: "Entregas",
                    type: "basic",
                    link: "/reports/historic/delivery",
                  },
                  {
                    id: "ave.reports.historic.delivery-incomplete",
                    title: "Entregas Incompletas",
                    type: "basic",
                    link: "/reports/historic/delivery-incomplete",
                  },
                  {
                    id: "ave.reports.historic.delivery-rejection",
                    title: "Entregas Rechazadas",
                    type: "basic",
                    link: "/reports/historic/delivery-rejection",
                  },
                  {
                    id: "ave.reports.historic.order-invoice",
                    title: "Facturas",
                    type: "basic",
                    link: "/reports/historic/order-invoice",
                  },
                  {
                    id: "ave.reports.historic.change-product",
                    title: "Cambios",
                    type: "basic",
                    link: "/reports/historic/change-product",
                  },
                  {
                    id: "ave.reports.historic.return-product",
                    title: "Devoluciones",
                    type: "basic",
                    link: "/reports/historic/return-product",
                  },
                  {
                    id: showV2
                      ? "ave.masters.routing.loss-report"
                      : "ave.reports.historic.loss-report",
                    title: "Mermas",
                    type: "basic",
                    link: showV2 ? "/master/routing/loss-report" : "/reports/historic/loss-list",
                  },
                ],
              },
              {
                id: "ave.reports.modify",
                title: "Modificaciones",
                type: "collapsable",
                children: [
                  {
                    id: "ave.reports.modify.order-customer-log",
                    title: "De Pedidos",
                    type: "basic",
                    link: "/reports/modify/order-customer-log",
                  },
                ],
              },
              {
                id: "ave.reports.historic.total-necessity",
                title: "Necesidad Total",
                type: "basic",
                link: "/reports/historic/total-necessity",
              },
              {
                id: showV2
                  ? "ave.reports.lost-sale-v2"
                  : "ave.reports.lost-sale",
                title: "Venta Perdida",
                type: "basic",
                link: showV2 ? "/reports/lost-sale-v2" : "/reports/lost-sale",
              },
              // {
              //   id: "ave.reports.lost-sale",
              //   title: "Venta Perdida",
              //   type: "basic",
              //   link: "/reports/lost-sale",
              // },
              // {
              //   id: "ave.reports.lost-sale-v2",
              //   title: "Venta Perdida",
              //   type: "basic",
              //   link: "/reports/lost-sale-v2",
              // },
              {
                id: "ave.reports.historic.proration",
                title: "Prorrateo",
                type: "basic",
                link: "/reports/historic/proration",
              },
              {
                id: "ave.reports.stock-break",
                title: "Quiebre de Inventario",
                type: "basic",
                link: "/reports/stock-break",
              },
              {
                id: "ave.masters.routing.liquidation-report",
                title: "Liquidaciones",
                type: "basic",
                link: "/master/routing/liquidation-report",
              },
              {
                id: "ave.reports.credit-application",
                title: "Solicitudes de crédito",
                type: "basic",
                link: "/reports/credit-application",
              }

            ],
          },
          {
            id: "ave.reports.visits",
            title: "Visitas",
            type: "collapsable",
            children: [
              {
                id: "ave.reports.visits.visit-check",
                title: "Check In/Out",
                type: "basic",
                link: "/reports/visits/visit-check",
              },
              {
                id: "ave.reports.visits.visit-report",
                title: "Efectividad",
                type: "basic",
                link: "/reports/visits/visit-report",
              },
            ],
          },
          {
            id: "ave.reports.finance",
            title: "Finanzas",
            type: "collapsable",
            children: [
              {
                id: "ave.reports.historic.order-payment",
                title: "Cobranzas",
                type: "basic",
                permission: ["ALL", "FICO"],
                link: "/reports/historic/order-payment",
              },
              {
                id: "ave.reports.historic.open-items",
                title: "Partidas Abiertas",
                type: "basic",
                permission: ["ALL", "FICO"],
                link: "/reports/historic/open-items",
              },              
              {
                id: "ave.reports.historic.expense-report",
                title: "Gastos",
                type: "basic",
                link: "/reports/historic/expense-report",
              },
            ],
          },
          {
            id: "ave.reports.finance",
            title: "Gestion de rutas",
            type: "collapsable",
            children: [
              {
                id: "ave.masters.routing.customer-route-frequency-report",
                title: "Cliente y Frecuencia de Rutas",
                type: "basic",
                link: "/master/routing/customer-route-frequency-report",
              },
              {
                id: "ave.masters.routing.customer-territories-report",
                title: "Clientes y territorios",
                type: "basic",
                link: "/master/routing/customer-territories-report",
              },
              {
                id: "ave.masters.routing.routes-territories-report",
                title: "Rutas de territorios",
                type: "basic",
                link: "/master/routing/routes-territories-report",
              },
            ],
          },
        ],
      },
    ],
  },
  //#endregion

  //#region DATA MAESTRA
  {
    id: "masters",
    title: "DATA MAESTRA",
    subtitle: "Datos Maestros",
    type: "group",
    icon: "heroicons_outline:document",
    children: [
      {
        id: "ave.masters.configuration",
        title: "Configuración",
        type: "collapsable",
        icon: "heroicons_outline:building-office-2",
        children: [
          {
            id: "ave.masters.business-partner.company",
            title: "Compañías",
            type: "basic",
            link: "/master/configuration/company",
          },
          {
            id: "ave.masters.business-partner.sales-organization",
            title: "Org. de Ventas",
            type: "basic",
            link: "/master/configuration/sales-organization",
          },
          {
            id: "ave.masters.business-partner.channel",
            title: "Canales de Distrib.",
            type: "basic",
            link: "/master/configuration/channel",
          },
          {
            id: "ave.masters.business-partner.distribution-chain",
            title: "Cadenas de Distrib.",
            type: "basic",
            link: "/master/configuration/distribution-chain",
          },
          {
            id: "ave.masters.business-partner.division",
            title: "Divisiones",
            type: "basic",
            link: "/master/configuration/division",
          },
          {
            id: "ave.masters.business-partner.office-group",
            title: "G. Oficinas de Venta",
            type: "basic",
            link: "/master/configuration/office-group",
          },
          {
            id: "ave.masters.business-partner.sales-office",
            title: "Oficinas de Venta",
            type: "basic",
            link: "/master/configuration/sales-office",
          },
          {
            id: "ave.masters.business-partner.plant",
            title: "Plantas",
            type: "basic",
            link: "/master/configuration/plant",
          },
          {
            id: "ave.masters.business-partner.warehouse",
            title: "Almacenes",
            type: "basic",
            link: "/master/configuration/warehouse",
          },
        ],
      },
      {
        id: "ave.masters.materials",
        title: "Gestión de Materiales",
        type: "collapsable",
        icon: "heroicons_outline:cube",
        children: [
          {
            id: "ave.masters.materials.material",
            title: "Materiales",
            type: "basic",
            link: "/master/materials/material",
          },
          {
            id: "ave.masters.materials.list-material",
            title: "Lista de Materiales",
            type: "basic",
            link: "/master/materials/list-material",
          },
          {
            id: "ave.masters.materials.material-group",
            title: "Grupos",
            type: "basic",
            link: "/master/materials/material-group",
          },
          {
            id: "ave.masters.materials.material-brand",
            title: "Marcas",
            type: "basic",
            link: "/master/materials/material-brand",
          },
          {
            id: "ave.masters.materials.group-units-of-measurement",
            title: "Grupos de Unidades de Medida",
            type: "basic",
            link: "/master/masters/group-units-of-measurement",
          },
          {
            id: "ave.masters.materials.units-of-measurement",
            title: "Unidades de Medida",
            type: "basic",
            link: "/master/masters/units-of-measurement",
          },
        ],
      },
      {
        id: "ave.masters.business-partner",
        title: "Socios de Negocio",
        type: "collapsable",
        icon: "heroicons_outline:user-group",
        children: [
          {
            id: "ave.masters.business-partner.business-partner",
            title: "Socios de Negocio",
            type: "basic",
            link: "/master/business-partner/business-partner",
          },
          {
            id: "ave.masters.business-partner.business-partner-news",
            title: "Nuevos Prospectos",
            type: "basic",
            link: "/master/business-partner/business-partner-news",
          },
          {
            id: "ave.masters.business-partner.request-credit",
            title: "Solicitud de crédito",
            type: "basic",
            link: "/master/business-partner/request-credit",
          },
          {
            id: "ave.masters.business-partner.business-partner-group",
            title: "Grupos",
            type: "basic",
            link: "/master/business-partner/business-partner-group",
          },
          {
            id: "ave.masters.business-partner.business-partner-subgroup",
            title: "Subgrupos",
            type: "basic",
            link: "/master/business-partner/business-partner-subgroup",
          },
          {
            id: "ave.masters.business-partner.pending-addresses",
            title: "Direcciones pendientes por aprobar",
            type: "basic",
            link: "/master/business-partner/pending-addresses",
          },
          {
            id: "ave.asset.asset-control",
            title: "Activos Asignados",
            type: "basic",
            link: "/asset/asset-control",
          },
          {
            id: "ave.masters.business-partner.payment-masters",
            title: "Condiciones",
            type: "collapsable",
            //icon: "heroicons_outline:banknotes",
            children: [
              {
                id: "ave.masters.business-partner.payment-masters.payment-condition",
                title: "De Pago",
                type: "basic",
                link: "/master/masters/payment-conditions",
              },
              {
                id: "ave.masters.masters.expedition-condition",
                title: "De Expedición",
                type: "basic",
                link: "/master/masters/expedition-condition",
              },
              {
                id: "ave.masters.masters.change-condition",
                title: "De Cambio",
                type: "basic",
                link: "/master/masters/change-condition",
              },
            ],
          },
          {
            id: "ave.masters.business-partner-business-partner",
            title: "Funciones",
            type: "collapsable",
            //icon: "heroicons_outline:users",
            children: [
              {
                id: "ave.masters.business-partner.business-partner-function",
                title: "De Interlocutor",
                type: "basic",
                link: "/master/business-partner/business-partner-function",
              },
              {
                id: "ave.masters.business-partner.business-partner-contact",
                title: "De Contacto",
                type: "basic",
                link: "/master/business-partner/business-partner-contact",
              },
            ],
          },
        ],
      },
      {
        id: "ave.masters.routing",
        title: "Gestión de Rutas",
        type: "collapsable",
        icon: "heroicons_outline:globe-alt",
        children: [
          {
            id: "ave.masters.routing.route",
            title: "Territorios",
            type: "basic",
            link: "/master/routing/route",
          },
          {
            id: "ave.masters.routing.route-area",
            title: "Áreas",
            type: "basic",
            link: "/master/routing/route-area",
          },
          {
            id: "ave.masters.routing.route-group",
            title: "Grupos",
            type: "basic",
            link: "/master/routing/route-group",
          },
          {
            id: "ave.masters.routing.sub-route",
            title: "Rutas",
            type: "basic",
            link: "/master/routing/sub-route",
          },
          {
            id: "ave.masters.routing",
            title: "Configuración",
            type: "collapsable",
            children: [
              {
                id: "ave.masters.routing.sub-route-activity",
                title: "Actividades",
                type: "basic",
                link: "/master/routing/sub-route-activity",
              },
              {
                id: "ave.masters.routing.sub-route-function",
                title: "Funciones",
                type: "basic",
                link: "/master/routing/sub-route-function",
              },
            ],
          },
        ],
      },
      {
        id: "ave.document",
        title: "Documentos",
        type: "collapsable",
        icon: "heroicons_outline:clipboard-document-list",
        children: [
          {
            id: "ave.document.class",
            title: "Clases",
            type: "basic",
            link: "/master/document/document-class",
          },
          {
            id: "ave.document.emission",
            title: "Punto de Emisión",
            type: "basic",
            link: "/master/document/emission-point",
          },
          {
            id: "ave.document.range",
            title: "Rangos",
            type: "basic",
            link: "/master/document/document-range",
          },
        ],
      },
      {
        id: "ave.masters.finance",
        title: "Finanzas",
        type: "collapsable",
        icon: "heroicons_outline:banknotes",
        children: [
          {
            id: "ave.masters.business-partner.payment-masters.banks",
            title: "Bancos",
            type: "basic",
            link: "/master/payment-masters/banks",
          },
          {
            id: "ave.master.finance.configuration",
            title: "Configuración",
            type: "collapsable",
            children: [
              {
                id: "ave.masters.masters.payment-method",
                title: "Métodos de Pago",
                type: "basic",
                link: "/master/payment-masters/payment-methods",
              },
              {
                id: "ave.masters.business-partner.payment-masters.payment-types",
                title: "Tipos de Pago",
                type: "basic",
                link: "/master/payment-masters/payment-types",
              },
            ],
          },
          {
            id: "ave.masters.business-partner.payment-masters.expense-reason",
            title: "Motivos de gastos",
            type: "basic",
            link: "/master/payment-masters/expense-reason",
          }
        ],
      },
      {
        id: "ave.masters.trade-policies",
        title: "Políticas Comerciales",
        type: "collapsable",
        icon: "heroicons_outline:currency-dollar",
        children: [
          {
            id: "ave.masters.trade-policies.price-list",
            title: "Data Maestra",
            type: "basic",
            link: "/master/masters/price-list",
          },
          {
            id: "ave.masters.trade-policies.strategy-list",
            title: "Configuración",
            type: "basic",
            link: "/master/masters/strategy-list",
          },
        ],
      },
      {
        id: "ave.transport",
        title: "Transporte",
        type: "collapsable",
        icon: "heroicons_outline:truck",
        children: [
          {
            id: "ave.transport.class",
            title: "Vehículo",
            type: "basic",
            link: "/master/transport/transport-vehicle",
          },
        ],
      },
      {
        id: "ave.asset",
        title: "Activos",
        type: "collapsable",
        icon: "heroicons_outline:rectangle-group",
        children: [
          {
            id: "ave.asset.asset",
            title: "Activos",
            type: "basic",
            link: "/asset/asset",
          },
          {
            id: "ave.asset.asset-group",
            title: "Grupos - SubGrupos",
            type: "basic",
            link: "/asset/asset-group",
          },
        ],
      },
      {
        id: "ave.masters.function-basics",
        title: "Funciones Básicas",
        type: "collapsable",
        icon: "heroicons_outline:adjustments-vertical",
        children: [
          {
            id: "ave.masters.masters.requirement",
            title: "Requisitos",
            type: "basic",
            link: "/master/masters/requirement",
          },
        ],
      },
    ],
  },
  //#endregion

  //#region SISTEMA
  {
    id: "system",
    title: "SISTEMA",
    subtitle: "Configuración General",
    type: "group",
    icon: "heroicons_outline:document",
    children: [
      {
        id: "system.access",
        title: "Accesos",
        type: "collapsable",
        icon: "heroicons_outline:identification",
        children: [
          {
            id: "system.configurations.users",
            title: "Usuarios",
            type: "basic",
            link: "/configurations/users",
          },
          {
            id: "system.configurations.groups",
            title: "Grupos",
            type: "basic",
            link: "/configurations/groups",
          },
          {
            id: "system.configurations.temporary-passwords",
            title: "Contraseñas Temporales",
            type: "basic",
            link: "/configurations/temporary-passwords",
          },
        ],
      },
      {
        id: "system.configurations",
        title: "Configuración",
        type: "collapsable",
        icon: "heroicons_outline:wrench-screwdriver",
        children: [
          {
            id: "system.configurations.menu-management",
            title: "Gestión de Menús",
            type: "collapsable",
            icon: "heroicons_outline:bars-3",
            children: [
              {
                id: "system.configurations.menu-items",
                title: "Elementos del Menú",
                type: "basic",
                link: "/menu-management/menu-items",
              },
              {
                id: "system.configurations.profiles",
                title: "Perfiles de Acceso",
                type: "basic",
                link: "/menu-management/profiles",
              },
            ],
          },
          {
            id: "system.configurations.external-keys",
            title: "Diccionario de Carga",
            type: "basic",
            link: "/configurations/external-keys",
          },
          {
            id: "ave.uploadFormat",
            title: "Formatos de Carga",
            type: "basic",
            link: "/uploadFormat/format-upload",
          },
          {
            id: "ave.synchronization",
            title: "Sincronización",
            type: "collapsable",
            children: [
              {
                id: "ave.synchronization.system-services",
                title: "Configuración",
                type: "basic",
                link: "/synchronization/system-services",
              },
              {
                id: "ave.synchronization.system-latency",
                title: "Latencia",
                type: "basic",
                link: "/synchronization/system-latency",
              },
            ],
          },
        ],
      },
      {
        id: "ave.notification",
        title: "Notificaciones",
        type: "collapsable",
        icon: "heroicons_outline:signal",
        children: [
          {
            id: "ave.synchronization.recipients",
            title: "Destinatarios",
            type: "collapsable",
            children: [
              {
                id: "ave.notification.notification-member",
                title: "Miembros",
                type: "basic",
                link: "/notification/notification-member",
              },
              {
                id: "ave.notification.notification-group",
                title: "Grupos",
                type: "basic",
                link: "/notification/notification-group",
              },
            ],
          },
          {
            id: "ave.notification.templates",
            title: "Plantillas",
            type: "basic",
            link: "/notification/templates",
          },
          {
            id: "ave.notification.notification",
            title: "Notificaciones",
            type: "basic",
            link: "/notification/notification",
          },
        ],
      },
      {
        id: "system.general",
        title: "General",
        type: "collapsable",
        icon: "heroicons_outline:rectangle-stack",
        children: [
          {
            id: "ave.masters.locations",
            title: "Localización",
            type: "collapsable",
            //icon: "heroicons_outline:map-pin",
            children: [
              {
                id: "ave.masters.locations.location-one",
                title: "Países",
                type: "basic",
                link: "/master/locations/location-one",
              },
              {
                id: "ave.masters.locations.location-two",
                title: "Departamentos",
                type: "basic",
                link: "/master/locations/location-two",
              },
              {
                id: "ave.masters.locations.location-three",
                title: "Ciudades",
                type: "basic",
                link: "/master/locations/location-three",
              },
              {
                id: "ave.masters.locations.location-four",
                title: "Colonias/Distritos",
                type: "basic",
                link: "/master/locations/location-four",
              },
            ],
          },
          {
            id: "ave.masters.general-function-basics",
            title: "Funciones Básicas",
            type: "collapsable",
            //icon: "heroicons_outline:map-pin",
            children: [
              {
                id: "ave.masters.masters",
                title: "Motivos",
                type: "collapsable",
                children: [
                  {
                    id: "ave.masters.masters.reason-for-visit",
                    title: "De Visita",
                    type: "basic",
                    link: "/master/masters/reasons-for-visit",
                  },
                  {
                    id: "ave.masters.masters.reason-for-rejection",
                    title: "De Rechazo",
                    type: "basic",
                    link: "/master/masters/reasons-for-rejection",
                  },
                  {
                    id: "ave.masters.masters.bad-condition-motives",
                    title: "De Mal Estado",
                    type: "basic",
                    link: "/master/masters/bad-condition-motives",
                  },
                  {
                    id: "ave.masters.masters.reason-for-block",
                    title: "De Bloqueo",
                    type: "basic",
                    link: "/master/masters/reasons-for-block",
                  },
                ],
              },
              {
                id: "ave.masters.types",
                title: "Tipos",
                type: "collapsable",
                //icon: "heroicons_outline:map-pin",
                children: [
                  {
                    id: "ave.document.type",
                    title: "De Documentos",
                    type: "basic",
                    link: "/master/document/document-type",
                  },
                  {
                    id: "ave.masters.business-partner.business-partner-type",
                    title: "De Socios de Negocios",
                    type: "basic",
                    link: "/master/business-partner/business-partner-type",
                  },
                  {
                    id: "ave.masters.masters.address-type",
                    title: "De Dirección",
                    type: "basic",
                    link: "/master/common/address-type",
                  },
                  {
                    id: "ave.masters.masters.phone-type",
                    title: "De Teléfono",
                    type: "basic",
                    link: "/master/common/phone-type",
                  },
                  {
                    id: "ave.masters.masters.rejection-type",
                    title: "De Rechazo",
                    type: "basic",
                    link: "/master/masters/rejection-type",
                  },
                  {
                    id: "ave.transport.type",
                    title: "De Transporte",
                    type: "basic",
                    link: "/master/transport/transport-type",
                  },
                  {
                    id: "ave.masters.masters.identity-document-type",
                    title: "De Documento de Identidad",
                    type: "basic",
                    link: "/master/masters/identity-document-type",
                  },
                ],
              },
            ],
          },
          {
            id: "ave.masters.masters.social-type",
            title: "Redes Sociales",
            type: "basic",
            link: "/master/common/social-media-type",
          },
        ],
      },
    ],
  },
  //#endregion
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];

export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];

export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];
